module.exports = __webpack_public_path__ + "img/5-exhaustfan.01cb5aa2.png";